<template>
  <div v-if="data !== null">
    <Top />
    <!-- Patienten är yngre än 18 år -->
    <!-- <div class="container" v-if="age < 18">
      <div class="clearfix"></div>
      <br />
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="header-wrapper">
            <h3 class="text-primary-fh left-header" v-html="data.screening.remittanceunder18Header"></h3>
          </div>
          <div class="clearfix"></div>
          <div class="card">
            <h5 class="text-primary-fh left-header" v-html="data.screening.remittanceunder18SubHeader"></h5>
            <p class="text-dark" v-html="data.screening.remittanceunder18Text"></p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix"></div>
          <router-link to="/dashboard" class="btn btn-primary btn-block btn-lg">
            Till min sida
          </router-link>
          <button
            class="btn btn-outline-dark btn-lg btn-block"
            @click="$router.go(-1)">
            &#8592; Tillbaka
          </button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div> -->
    <!-- Patienten är 18 år eller äldre -->
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix"></div>
          <Pagination :numberOfDots="5" :numberOfVisitedDots="5" />
          <div class="clearfix"></div>
          <div class="header-wrapper">
            <h2 class="text-primary-fh left-header" v-html="data.screening.createremittanceheader"></h2>
          </div>
          <div class="card">
            <h5 class="text-primary-fh left-header">Såhär har du svarat på frågorna:</h5>
            <div v-if="screening.length === 0"><p class="text-muted"><i>Ej svarat ännu</i></p></div>
            <div v-if="screening.length > 0">
              <div class="parent" v-for="(a, i) in screening" v-bind:key="i">
                <p>
                  {{ a.question }}
                  <br />
                  ➢ {{ a.answer }}
                  <span v-if="a.eggs">{{ a.eggs.answer }}</span>
                </p>
                <div v-for="(d, i) in a.drugs" v-bind:key="i">
                  <table class="table table-striped" v-if="d.dose !== 0 && d.unit !== 0 && d.amountperday !== 0">
                    <tr>
                      <th>Läkemedel</th>
                      <th>Dos</th>
                      <th>Enhet</th>
                      <th>Frekvens</th>
                    </tr>
                    <tr>
                      <td>{{ toTitleCase(d.name) }}</td>
                      <td>{{ d.dose }}</td>
                      <td>{{ d.unit }}</td>
                      <td>{{ d.amountperday || d.injectionsperweek }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <br />
          <p v-html="data.screening.createremittancetext"></p>
            <h5 class="text-primary-fh left-header" v-html="data.screening.createremittancecityheader"></h5>
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <!-- Städer -->
          <select class="form-control" v-model="chosenCityLabId" :disabled="paperReferral">
            <option :value="0">-- Ange stad --</option>
            <option v-for="(labId, city) in data.misc.remittancelist" :value="labId" :key="city">
              {{ city }}
            </option>
          </select>
          <div class="clearfix"></div>
          <p class="text-primary-fh text-center">eller..</p>
          <div class="clearfix"></div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="paperReferral"
              :disabled="chosenCityLabId !== 0"
              id="paperReferral"
            >
            <label
              class="form-check-label"
              for="paperReferral"
              v-html="data.screening.createremittancepaperreftext">
            </label>
          </div>
          <div class="alert alert-warning alert-error" v-html="errmsg"></div>
          <div class="clearfix"></div>
          <button
            class="btn btn-primary btn-lg btn-block"
            @click="createRemittance" :disabled="chosenCityLabId === 0 && !paperReferral">
            Klar
          </button>
          <div class="clearfix"></div>
          <button
            class="btn btn-outline-dark btn-lg btn-block"
            @click="$router.go(-1)">
            &#8592; Tillbaka
          </button>
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import $ from 'jquery'

export default {
  name: 'createremittance',
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null,
      chosenCityLabId: 0,
      paperReferral: false,
      age: null,
      screening: [],
      errmsg: 'Något gick fel vid skapande av remiss - vänligen försök igen.'
    }
  },
  methods: {
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    createRemittance () {
      const r = confirm('Är du säker på att du vill skapa remiss? Kolla så att du svarat korrekt på frågorna samt valt rätt stad.')
      if (r) {
        let loader = this.$loading.show()
        let labId = (this.chosenCityLabId !== 0) ? this.chosenCityLabId : null
        if (labId && labId.includes('___')) {
          /* In DatoCMS to remittanceList I added for example A1345_1/2/3 because otherwise
            you would choose the same city with same labId. I needed a separator and here is
            where I remove it and send it correctly to server. [Commented 2020-12-02]
            - Remittance list from DatoCMS is updated but this still applies to some cities. [Commented 2023-01-26]
          */
          labId = labId.substring(0, labId.indexOf('___'))
        }
        axios.postReferral(config.referralUri, labId, this.paperReferral).then((response) => {
          if (response.status === 200) {
            loader.hide()
            this.$router.push('dashboard')
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else if (error.response && error.response.status === 417) {
            loader.hide()
            this.$router.push({ name: 'error',
              params: { '0': 'error', type: 'referral', message: error.response.data.errorMessage }})
          } else {
            loader.hide()
            this.errmsg = error.response.data[0] ? error.response.data[0] : this.errmsg
            $('.alert-error').show().delay(config.msInterval).fadeOut()
          }
        })
      }
    }
  },
  beforeMount () {
    const age = localStorage.getItem('age')
    if (age) {
      this.age = parseInt(age)
    }
    let loader = this.$loading.show()
    axios._get(config.screeningAnswerUri).then(response => {
      const answers = response.data.answers
      answers.forEach(a => {
        if (a) {
          this.screening.push(JSON.parse(a.answer))
        }
      })
      loader.hide()
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        loader.hide()
        window.location.href = window.location.origin.concat('/error')
      } else {
        console.log('Request went bad to screeninganswers: ' + error)
        loader.hide()
      }
    })
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          screening {
            createremittanceheader
            createremittancetext
            createremittancecityheader
            createremittancepaperreftext
            remittanceunder18Header
            remittanceunder18SubHeader
            remittanceunder18Text
          }
          misc {
            remittancelist
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type=checkbox] {
  transform: scale(1.5);
}
.alert {
  display: none;
}
.card {
  padding: 1em;
}
.container {
  margin-top: 9vh;
  margin-bottom: 7vh;
  min-height: 70vh;
}
.page-item {
  color: transparent !important;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
.form-check-label {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateRemittance.vue